<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'管理员配置'}]" :title="'管理员配置'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">账号状态</span>
                        <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">管理员类型</span>
                        <el-select v-model="sendInfoOne.administratorType" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in administratorTypeList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                    <el-button type="primary" size="small" @click="edit()" icon="el-icon-plus"
					v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:add')!=-1"
					>添加</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
               ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="管理员编号">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="realName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="administratorType"
                    show-overflow-tooltip
                    
                    label="管理员类型">
                </el-table-column>
                <el-table-column
                    prop="roleName"
                    show-overflow-tooltip
                    
                    width="200"
                    label="角色">
                </el-table-column>
                <el-table-column
                    prop="statusName"
                    show-overflow-tooltip
                    
                    label="账号状态">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:view')!=-1 ||
                    authorities.indexOf('sys:permission:background:administrator:config:list:button:edit')!=-1 ||
                    authorities.indexOf('sys:permission:background:administrator:config:list:button:reset:password')!=-1 ||
                    authorities.indexOf('sys:permission:background:administrator:config:list:button:status')!=-1"
                    label="操作"
                    
                    width="400">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)" 
						v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:view')!=-1"
						>查看</el-button>
                        <el-button size="small" type="primary" class="super" plain  @click="edit(scope.row)"  :disabled="scope.row.userName === 'superAdmin'"
						v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:edit')!=-1"
						>编辑</el-button>
                        <el-button size="small" type="primary" class="super" plain  @click="resetPW(scope.row)"
						v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:reset:password')!=-1"
						>重置密码</el-button>
                        <el-button size="small" :type="scope.row.statusButtonName === '启用'?'success':'warning'" class="super" plain  @click="sold(scope.row)"  :disabled="scope.row.userName === 'superAdmin'"
						v-if="authorities.indexOf('sys:permission:background:administrator:config:list:button:status')!=-1"
						>{{scope.row.statusButtonName}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="sendInfoOne.currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="管理员明细"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{detail.realName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">账号：</div>
                        <div class="content">{{detail.createUserName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">管理员类型：</div>
                        <div class="content">{{detail.administratorTypeName}}</div>
                    </div>
                    <div class="childMulti">
                        <div class="name">绑定角色：</div>
                        <ul>
                            <li v-for="(item,index) in detail.roleNames" :key="index">{{item}}</li>
                        </ul>
                    </div>
                    <div class="child">
                        <div class="name">创建人：</div>
                        <div class="content">{{detail.createName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">创建时间：</div>
                        <div class="content">{{detail.createTime}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新人：</div>
                        <div class="content">{{detail.modifyName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{detail.updateTime}}</div>
                    </div>
                </div>
            </el-dialog>
            <!-- 编辑 -->
            <el-dialog
                :title="editType=='1'?'新增':'编辑'"
                :visible.sync="dialogEdit"
                :before-close="cancel"
                :close-on-click-modal="false"
                width="40%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>姓名：</div>
                        <el-input v-model="sendInfoTwo.dto.realName" maxlength="20"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.dto.realName']">错误提示：{{errors['sendInfoTwo.dto.realName']}}</div>
                    <div class="child">
                        <div class="name"><span v-if="editType=='1'">*</span>账号：</div>
                        <el-input v-model="sendInfoTwo.dto.userName" maxlength="20" v-if="editType=='1'"></el-input>
                        <div class="content" v-else>{{sendInfoTwo.dto.userName}}</div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.dto.userName'] && editType=='1'">错误提示：{{errors['sendInfoTwo.dto.userName']}}</div>
                    <div class="child">
                        <div class="name">初始密码：</div>
                        <div class="content">账号初始密码与账号相同，请管理员尽快修改密码</div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>管理员类型：</div>
                        <el-radio-group v-model="sendInfoTwo.dto.administratorType" @change="radioChange">
                            <el-radio :label="item.value" v-for="(item,index) in administratorTypeList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.dto.administratorType']">错误提示：{{errors['sendInfoTwo.dto.administratorType']}}</div>
                    <div class="child" v-show="sendInfoTwo.dto.administratorType=='SYSTEM_ADMINISTRATOR'">
                        <div class="name">绑定角色：</div>
                        <el-transfer v-model="sendInfoTwo.dto.roleIds" :data="transferList" :titles="['未选', '已选']" :props="{key: 'id',label: 'roleName'}"></el-transfer>
                    </div>
                    <div class="doubleBtn">
                        <el-button type="primary" @click="cancel">取消</el-button>
                        <el-button type="primary" @click="submit">确认</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            statusList:[],//账号状态数组
            administratorTypeList:[],//管理员类型数组
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }],//检索下拉
            getSelect:'',//检索下拉的值
            getValue:null,//检索输入框的值
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//条数
                status:null,//账号状态
                administratorType:null,//管理员类型
                userName:null,//账号
                realName:null,//姓名
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tableData:[],//表格数据
            totalSize:null,//总跳数
            dialogInfo:false,//查看明细弹出层
            detail:{},//明细
            dialogEdit:false,//编辑弹出层
            editType:null,//判断编辑类型 新增或编辑
            sendInfoTwo:{
                id:null,//修改用户id
                dto:{
                    administratorType:null,//管理员类型
                    realName:null,//姓名
                    roleIds:[],//id数组
                    userName:null,//账号
                }
            },//编辑提交数据
            transferList:[],//穿梭框数据
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.dto.realName':'realName',
        'sendInfoTwo.dto.userName':'userName',
        'sendInfoTwo.dto.administratorType':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择管理员类型'
        },
    },
    methods:{
      onReset(){
        const params = {
          currentPage:1,//当前页
                pageSize:10,//条数
                status:null,//账号状态
                administratorType:null,//管理员类型
                userName:null,//账号
                realName:null,//姓名
                property:null,//排序字段
                direction:null,//排序方式
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,params)
        this.getSelect = void 0
        this.getValue = void 0
        this.getData()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //查看明细
        check:function(row){
            // this.$axiosz.get('backstage/administrator/view/'+row.id).then((r)=>{
            //     if(r.code==200){
            //         this.dialogInfo=true;
            //         this.detail=r.data;
            //     }else{
            //         this.$alert(r.msg)
            //     }
            // })
            this.$router.push({path: `/systemLayout/administrator/detail/${row.id}`, query: {index: '/systemLayout/administrator'},param:{id:row.id}})
        },
        //打开编辑
        edit:function(row){
            this.$vuerify.clear();
            if(row){//编辑
                this.editType='2';
                // this.sendInfoTwo.id=row.id;
                // this.$axiosz.get('backstage/administrator/echo',{params:{id:row.id}}).then((r)=>{
                //     if(r.code==200){
                //         this.sendInfoTwo.dto.realName=r.data.realName;
                //         this.sendInfoTwo.dto.userName=r.data.userName;
                //         this.sendInfoTwo.dto.administratorType=r.data.administratorType;
                //         this.transferList=[...r.data.notSelectRoles,...r.data.selectRoles];
                //         if(r.data.selectRoles){
                //             for(let item of r.data.selectRoles){
                //                 this.sendInfoTwo.dto.roleIds.push(item.id);
                //             }
                //         }
                //     }else{
                //         this.$alert(r.msg)
                //     }
                // })
                this.$router.push({path: `/systemLayout/administrator/add/${row.id}`, query: {index: '/systemLayout/administrator'},param:{id:row.id}})
            }else{//新增
                this.editType='1';
               this.$router.push({path: `/systemLayout/administrator/add`, query: {index: '/systemLayout/administrator'}})
            }
            
            //this.dialogEdit=true;
        },
        //单选切换获取穿梭框数组
        radioChange:function(val){
            if(val=='SYSTEM_ADMINISTRATOR'){ //系统管理员 穿梭框
                this.$axiosz.get('backstage/administrator/echo',{params:{id:this.sendInfoTwo.id}}).then((r)=>{
                    if(r.code==200){
                        if(r.data.selectRoles && r.data.selectRoles.length>0){
                            this.transferList=[...r.data.notSelectRoles,...r.data.selectRoles];
                        }else{
                            this.transferList=[...r.data.notSelectRoles];
                        }
                        if(r.data.selectRoles && r.data.selectRoles.length>0){
                            for(let item of r.data.selectRoles){
                                this.sendInfoTwo.dto.roleIds.push(item.id);
                            }
                        }
                    }else{
                        this.$alert(r.msg)
                    }
                })
            }
        },
        //取消按钮
        cancel:function(){
            this.dialogEdit=false;
            this.editType=null,
            this.sendInfoTwo.id=null;
            this.sendInfoTwo.dto.realName=null;
            this.sendInfoTwo.dto.userName=null;
            this.sendInfoTwo.dto.administratorType=null;
            this.transferList=[];
            this.sendInfoTwo.dto.roleIds=[];
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                if(this.editType==1){ //新增
                    this.$axiosz.get('backstage/administrator/userName/'+this.sendInfoTwo.dto.userName).then((r)=>{
                        if(r.code==200){
                            this.$axiosz({
                                method: 'post',
                                url: 'backstage/administrator',
                                data: this.sendInfoTwo.dto,
                                headers: { 'content-type': 'application/json;charset=UTF-8' },
                            }).then((r)=>{
                                if(r.code==200){
                                    this.$message({
                                        type: 'success',
                                        message: '添加成功!'
                                    });
                                    this.getData();
                                    this.cancel();
                                }else{
                                    this.$alert(r.msg)
                                }
                            })
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }else{ //编辑
                    this.$axiosz({
                        method: 'put',
                        url: 'backstage/administrator/'+this.sendInfoTwo.id,
                        data: this.sendInfoTwo.dto,
                        headers: { 'content-type': 'application/json;charset=UTF-8' },
                    }).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            this.getData();
                            this.cancel();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }
            }   
        },
        //重置密码
        resetPW:function(row){
            if(row.status==1){
                this.$confirm('确认重置为初始密码？', '重置密码', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axiosz.put('backstage/administrator/password/' + row.id).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '重置成功!'
                            });
                            this.getData();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }).catch(() => {});
            }else{
                this.$message({
                    type: 'warning ',
                    message: '禁用状态不可重置密码!'
                });
            }
        },
        //禁用
        sold:function(row){
            let str='';
            if(row.statusButtonName=='启用'){
                str='确认启用？'
            }else{
                str='如果该管理员下有正在处理的编辑工作等，禁用后工作将挂起，确认是否禁用？'
            }
            this.$confirm(str, row.statusButtonName, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axiosz.put('backstage/administrator/status/'+row.id).then((r)=>{
                    if(r.code==200){
                        this.$message({
                            type: 'success',
                            message: row.statusButtonName+'成功!'
                        });
                        this.getData();
                    }else{
                        this.$alert(r.msg)
                    }
                })
            }).catch(() => {});
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/STATUS').then((r)=>{ //账号状态
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
            this.$axiosz.get('backstage/sysDict/ADMINISTRATOR_TYPE').then((r)=>{ //管理员类型
                if(r.code==200){
                    this.administratorTypeList=r.data;
                }
            })
        },
        //获取数据
        getData(){
            this.loading = true
            if(this.getSelect=='1'){ //id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else{ //姓名
                this.sendInfoOne.realName=this.getValue;
            }
            this.$axiosz.get('backstage/administrator',{params:this.sendInfoOne}).then((r)=>{
              this.loading = false
                if(r.code==200){
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                }else{
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        },
    },
    mounted(){
        const that = this
        that.getDic();
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>

</style>